import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import globalConfigReducer from "../../store/global/reducer";
import securityQuestionsReducer from "../../common/ProfileMgmtUtils/SecurityQuestionsReducer";
import languageProviderReducer from "../../containers/LanguageProvider/module/reducer";
import templateMailManagementReducer from "../../pages/AdminConsole/TemplateMailManagement/module/reducer";
import templateSmsManagementReducer from "../../pages/AdminConsole/TemplateSmsManagement/module/reducer";
import workflowManagementReducer from "../../pages/AdminConsole/WorkflowManagement/module/reducer";
import approvalManagementReducer from "../../pages/ApprovalsManagement/module/reducer";
import brManagementReducer from "../../pages/BusinessRolesManagement/module/reducer";
import catalogReducer from "../../pages/CatalogManagement/module/reducer";
import certificationReferenceReducer from "../../pages/CertificationReference/module/reducer";
import changePasswordReducer from "../../pages/ChangePassword/module/reducer";
import createCertificaionReducer from "../../pages/CreateCertifaction/module/reducer";
import EmergencyUsersReducer from "../../pages/EmergencyUsers/module/reducer";
import entitlementReferenceReducer from "../../pages/EntitlementReference/module/reducer";
import userEntitlementReducer from "../../pages/UserEntitlements/module/reducer";
import externalPortalReducer from "../../pages/ExternalPortal/module/reducer";
import loginReducer from "../../pages/Login/module/reducer";
import manualReferenceReducer from "../../pages/ManualsReference/module/reducer";
import profileManagementReducer from "../../pages/ProfileManagement/module/reducer";
import ReportReducer from "../../pages/Report/module/reducer";
import resetPasswordReducer from "../../pages/ResetPassword/module/reducer";
import ServiceRequestReducer from "../../pages/ServiceRequest/module/reducer";
import taskManagementReducer from "../../pages/TaskManagement/module/reducer";
import userRefereceReducer from "../../pages/UsersReference/module/reducer";
import welcomeReducer from "../../pages/Welcome/module/reducer";
import loaderWrapperReducer from "./../../components/LoarderWrapper/module/reducer";
import sidebarReducer from "./../../components/Sidebar/module/reducer";
import errorBoundaryReducer from "./../../containers/ErrorBoundary/module/reducer";
import entitlementsManagementReducer from "./../../pages/AbilitationManagement/module/reducer";
import delegationManagementReducer from "./../../pages/DelegationManagement/module/reducer";
import historyRequestReducer from "./../../pages/HistoryRequest/module/reducer";
import temporaryAbilitationsReducer from "./../../pages/TemporaryAbilitations/module/reducer";
import twoFactorAuthReducer from "../../common/TwoFactorAuth/module/reducer";
import technicalUsersReducer from "../../pages/TechnicalUser/module/reducer";

// CONSOLE ADMIN
import tablesConfigurationReducer from "../../common/TablesConfiguration/tcReducer";
import consoleAdminApplicationEntitlementManagementReducer from "../../pages/AdminConsole/ApplicationsAbilitationsManagement/module/reducer";
import adminAuditManagementReducer from "../../pages/AdminConsole/AuditManagement/module/reducer";
import adminBRManagementReducer from "../../pages/AdminConsole/BRManagement/module/reducer";
import consoleAdminCatalogManagementReducer from "../../pages/AdminConsole/CatalogManagement/module/reducer";
import adminCertificationConfigurationsReducer from "../../pages/AdminConsole/CertificationConfigurationsManagement/module/reducer";
import externalPortalManagementReducer from "../../pages/AdminConsole/ExternalPortalManagement/module/reducer";
import manualsManagementReducer from "../../pages/AdminConsole/ManualsManagement/module/reducer";
import notifyManagementReducer from "../../pages/AdminConsole/NotifyAdminManagement/module/reducer";
import passwordPropagationReducer from "../../pages/AdminConsole/PasswordManagement/module/reducer";
import profilesManagementReducer from "../../pages/AdminConsole/ProfilesManagement/module/reducer";
import adminRecoveryPointReducer from "../../pages/AdminConsole/RecoveryPointManagement/module/reducer";
import reportParameterReducer from "../../pages/AdminConsole/ReportManagement/ParameterSection/module/reducer";
import reportReducer from "../../pages/AdminConsole/ReportManagement/ReportSection/module/reducer";
import consoleAdminServiceRequestReducer from "../../pages/AdminConsole/ServiceRequestManagement/module/reducer";
import sodManagementReducer from "../../pages/AdminConsole/SODManagement/module/reducer";
import tablesConfigurationManagementReducer from "../../pages/AdminConsole/TablesConfigurationManagement/module/reducer";
import temporaryAbilitationsManagementReducer from "../../pages/AdminConsole/TemporaryAbilitationsManagement/module/reducer";
import usersManagementReducer from "../../pages/AdminConsole/UsersManagement/module/reducer";
import uigpManagementReducer from "../../pages/AdminConsole/UigpManagement/module/reducer";
import csvManagementReducer from "../../pages/AdminConsole/CsvUploaderManagement/module/reducer";
import adminTechnicalUserReducer from "../../pages/AdminConsole/TechnicalUsersManagement/module/reducer";

import { connectRouter } from "connected-react-router";

import { actionTypes } from "../../App/module/actions";
import AppReducer from "./../../App/module/reducers";
class BaseAction {
  constructor(public type: string, public payload: any) {}
}

const getRootReducer = (
  state: any,
  action: BaseAction,
  history: any,
  asyncReducers: () => {}
) => {
  return combineReducers({
    app: AppReducer,
    form: formReducer,
    globalState: globalConfigReducer,
    twoFactorState: twoFactorAuthReducer,
    loader_wrapper: loaderWrapperReducer,
    sidebar: sidebarReducer,
    historyRequest: historyRequestReducer,
    entitlementsManagement: entitlementsManagementReducer,
    approvalManagement: approvalManagementReducer,
    taskManagement: taskManagementReducer,
    catalog: catalogReducer,
    delegationManagement: delegationManagementReducer,
    entitlementReference: entitlementReferenceReducer,
    userReference: userRefereceReducer,
    userEntitlement: userEntitlementReducer,
    emergencyUsers: EmergencyUsersReducer,
    brManagement: brManagementReducer,
    errorBoundary: errorBoundaryReducer,
    language: languageProviderReducer,
    resetPassword: resetPasswordReducer,
    createCertification: createCertificaionReducer,
    manualReference: manualReferenceReducer,
    profileManagement: profileManagementReducer,
    changePassword: changePasswordReducer,
    certificationReference: certificationReferenceReducer,
    consoleAdminTemplateMailMgmt: templateMailManagementReducer,
    consoleAdminTemplateSmsMgmt: templateSmsManagementReducer,
    serviceRequest: ServiceRequestReducer,
    temporaryAbilitations: temporaryAbilitationsReducer,
    technicalUsers: technicalUsersReducer,
    report: ReportReducer,
    securityQuestions: securityQuestionsReducer,
    consoleAdminWorkflowMgmt: workflowManagementReducer,
    tablesConfigurationManagement: tablesConfigurationManagementReducer,
    tablesConfiguration: tablesConfigurationReducer,
    consoleAdminCatalogMgmt: consoleAdminCatalogManagementReducer,
    consoleAdminManualsMgmt: manualsManagementReducer,
    consoleAdminPasswPropagationMgmt: passwordPropagationReducer,
    consoleAdminReportMgmtReport: reportReducer,
    consoleAdminReportMgmtParameter: reportParameterReducer,
    consoleAdminProfilesManagement: profilesManagementReducer,
    consoleAdminExternalPortalMgmt: externalPortalManagementReducer,
    externalPortal: externalPortalReducer,
    welcomeState: welcomeReducer,
    consoleAdminSodManagement: sodManagementReducer,
    consoleAdminApplicationEntitlementMgmt:
      consoleAdminApplicationEntitlementManagementReducer,
    adminUserManagement: usersManagementReducer,
    consoleAdminServiceRequestReducer: consoleAdminServiceRequestReducer,
    consoleAdminRecoveryPoint: adminRecoveryPointReducer,
    consoleAdminCertificationConfigurations:
      adminCertificationConfigurationsReducer,
    consoleAdminAudit: adminAuditManagementReducer,
    consoleAdminNotifyMgmt: notifyManagementReducer,
    consoleAdminBRMgmt: adminBRManagementReducer,
    consoleAdminTemporaryAbilitationsMgmt:
      temporaryAbilitationsManagementReducer,
    consoleAdminUigpManagement: uigpManagementReducer,
    consoleAdminCsvUploader: csvManagementReducer,
    consoleAdminTechnicalUser: adminTechnicalUserReducer,
    router: connectRouter(history),
    login: loginReducer,
    ...asyncReducers,
  })(state, action);
};

export const makeRootReducer = (asyncReducers: () => {}, history: any) => {
  return (state: any, action: BaseAction) => {
    if (action.type === actionTypes.LOGOUT) {
      sessionStorage.clear();
      state = undefined;
    }
    if (
      action &&
      action.type === "@@router/LOCATION_CHANGE" &&
      action.payload.location.pathname === "/welcome"
    ) {
      state.form = {};
    }
    if (
      action &&
      action.type === "@@router/LOCATION_CHANGE" &&
      action.payload.location.pathname === "/admin"
    ) {
      state.form = {};
    }

    return getRootReducer(state, action, asyncReducers, history);
  };
};

export default makeRootReducer;
